/**
 * Server-safe column ids + table display defaults for DEFAULT_USER_DISPLAY_PREFERENCES.
 * Keep in sync with ./columns.tsx.
 */

export const user_column_display_seeds: {
    id: string;
    defaultDisplayPreferences: {
        order: number;
        size: number;
        visible: boolean;
        pinned: boolean;
        displayAs: "number" | "string" | "date" | "other";
    };
}[] = [
    {
        id: "firstName",
        defaultDisplayPreferences: {
order: 1, visible: true, size: 150, pinned: false, displayAs: "string"
        },
    },
    {
        id: "lastName",
        defaultDisplayPreferences: {
order: 2, visible: true, size: 150, pinned: false, displayAs: "string"
        },
    },
    {
        id: "email",
        defaultDisplayPreferences: {
order: 3, visible: true, size: 250, pinned: false, displayAs: "string"
        },
    },
    {
        id: "roles",
        defaultDisplayPreferences: {
order: 4, visible: true, size: 450, pinned: false, displayAs: "string"
        },
    },
    {
        id: "createdAt",
        defaultDisplayPreferences: {
order: 14, visible: true, size: 120, pinned: false, displayAs: "date"
        },
    },
];
